import { render, staticRenderFns } from "./FilterMarketplace.vue?vue&type=template&id=0274a35b&"
import script from "./FilterMarketplace.vue?vue&type=script&lang=js&"
export * from "./FilterMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports